import { VFlow } from 'bold-ui'
import CheckPermission from 'components/auth/CheckPermission'
import { useSegurancaQuery } from 'graphql/hooks.generated'
import Permissions from 'types/Permissions.generated'
import { SegurancaBox } from 'view/configuracoes/instalacao/seguranca/SegurancaBox'

export const SegurancaView = () => {
  const { data, refetch } = useSegurancaQuery()

  return (
    <>
      {data && data.seguranca && (
        <VFlow vSpacing={2}>
          <CheckPermission permission={Permissions.configuracaoDeInstalacao.configurarSeguranca}>
            <SegurancaBox
              loginNumeroTentativas={data.seguranca.loginNumeroTentativas}
              periodoEmMesesParaRedefinir={data.seguranca.periodoEmMesesParaRedefinir}
              periodoEmMinutosInatividade={data.seguranca.periodoEmMinutosInatividade}
              load={refetch}
            />
          </CheckPermission>
        </VFlow>
      )}
    </>
  )
}
